module.exports = __webpack_public_path__ + "img/signe.20235eb0.svg";